import { MSkeleton } from "src/ui/MSkeleton/MSkeleton"

export function PaymentMethodLoading() {
  return (
    <MSkeleton variant="rect" height={130} style={{ borderRadius: "14px" }} />
  )
}
